module.exports = __webpack_public_path__ + "img/user-face-photo-pic.c0732baa.png";